import { Component, inject, OnInit, signal, } from '@angular/core';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { ToolsService } from '../../services/tools.service';
import { ToolsDto } from '../../dtos/tools.dto';
import { FieldsetModule } from 'primeng/fieldset';
import { TooltipModule } from 'primeng/tooltip';
import { ButtonModule } from 'primeng/button';
import { MessageModule } from 'primeng/message';
import { Router, RouterModule } from '@angular/router';
import { DialogModule } from 'primeng/dialog';
import { environment } from "../../../../environments/environment"
import { ToastService } from '../../../../common/services/toast.service';
import { IftaLabelModule } from 'primeng/iftalabel';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { Subject, debounceTime, distinctUntilChanged, takeUntil } from 'rxjs';
@Component({
  selector: 'app-view-tools',
  standalone: true,
  imports: [
      TableModule,
      FieldsetModule,
      TooltipModule,
      ButtonModule,
      MessageModule,
      RouterModule,
      DialogModule,
      IftaLabelModule,
      InputTextModule,
      ReactiveFormsModule
  ],
  providers: [ToolsService],
  templateUrl: './view-tools.html',
  styleUrls: ['./view-tools.css']
})
export class ViewToolsComponent implements OnInit  {

  loading = signal<boolean>(false);
  tools:Array<ToolsDto> = new Array<ToolsDto>()
  toolsService = inject(ToolsService)
  private router = inject(Router);
  selectedTool!:ToolsDto
  toolCredentialsDialogVisible = false;
  displayTool: ToolsDto | null = null;
  first: number = 0;
  rows: number = 10;
  totalRecords = signal<number>(0);
  sortField = 'name';
  sortOrder = 'ASC';
  toastService = inject(ToastService);
  commonDetails:{
    platformURL:string,
       authenticationURL:string,
       accessTokenURL:string,
       jwksURL:string
  }={
     platformURL:environment.platformApiURL,
     authenticationURL:`${environment.platformApiURL}/oidc/authenticate`,
     accessTokenURL:`${environment.platformApiURL}/oidc/access/token`,
     jwksURL:`${environment.platformApiURL}/well-known/jwks.json`
  };
  searchQuery:FormControl = new FormControl();
  private destroy$ = new Subject<void>();
  private isSearchTriggered = false;

  ngOnInit() {
      //TODO: to implement search functionality later.
      this.searchQuery.valueChanges.pipe(
         debounceTime(300),
         distinctUntilChanged(),
         takeUntil(this.destroy$)
      ).subscribe((value: string) => {
        if (value && value.length >= 3) {
           this.isSearchTriggered = true;
           this.first = 0;
           this.loadTools({
             skip: 0,
             limit: this.rows,
             sortField: this.sortField,
             sortOrder: this.sortOrder
           });
        } else if (!value || value.length === 0) {
          // Reset to show all results when search is cleared
           this.isSearchTriggered = true;
           this.first = 0;
           this.loadTools({
             skip: 0,
             limit: this.rows,
             sortField: this.sortField,
             sortOrder: this.sortOrder
           });
        }
      });
    }
  onLazyLoad(event: TableLazyLoadEvent) {
    this.loadTools({ 
      skip: event.first ?? 0,
      limit: event.rows ?? 10,
      sortField: event.sortField as string ?? 'name',
      sortOrder: event.sortOrder === 1 ? 'ASC' : 'DESC' });
  }
  async loadTools({skip,limit,sortField,sortOrder}:{skip:number,limit:number,sortField:string,sortOrder:string}){
    this.loading.set(true);
    const response = await this.toolsService.getTools({skip,limit,sortField,sortOrder,searchQuery:this.searchQuery.value});
    this.tools = response.data
    this.totalRecords.set(response.total);
    this.loading.set(false);
  }
  goToAddToolsPage(){
    this.router.navigate(['/add-tool'])
  }
  showToolCredentials(tool:ToolsDto){
    this.displayTool = {
      ...tool,
    };
    this.toolCredentialsDialogVisible = true;
  }
  copyCredentialsToClipboard(displayTool:ToolsDto){
    if(displayTool){
      const text = `
            Name:  ${ displayTool.name }\n
            Client ID:  ${ displayTool.clientId }\n
            Deployment ID:  ${ displayTool.deploymentId }\n
            Platform URL:  ${this.commonDetails.platformURL }\n
            Authentication URL:  ${ this.commonDetails.authenticationURL }\n
            Access Token URL:  ${ this.commonDetails.accessTokenURL }\n
            JWKS URL:  ${ this.commonDetails.jwksURL }
      `;
        navigator.clipboard.writeText(text);
        this.toastService.show({
          severity:"success",
          summary:"Copied!",
          detail:"Copied to clipboard."
        })
        this.toolCredentialsDialogVisible = false
    }
    
  }
  editTool(tool:ToolsDto){

  }
  deleteTool(tool:ToolsDto){
    
  }
}
